import React from "react";
import { useHistory } from "react-router-dom";
import PngLogo from "../../../assets/images/png/luaa_logo.png";
import { CancelIcon } from "../../../assets/images/svgs";
import {
  SideNav as SideNavStyle,
  SideNavBottom,
  SideNavCenter,
  SideNavTop,
} from "./style";
import {
  STUDENT_NAVIGATION,
  SUPER_ADMIN_NAVIGATION,
  SYSTEM_ADMIN_NAVIGATION,
} from "../../../utils/helpers/sideNavItems";
import SideNavItem from "./Items";
import { AccountPath } from "../../../utils/mapper/enums/accountType";

export default function SideNav({ type, pathname, sideNavToggle, isMessage }) {
  const history = useHistory();
  const handleItemClick = (index, item) => {
    if (item.tab) {
      return history.push(
        `/dashboard/${type}${item.url.toLowerCase()}/${item.tab.toLowerCase()}`
      );
    }
    return history.push(`/dashboard${type}${item.url.toLowerCase()}`);
  };

  return (
    <SideNavStyle>
      <SideNavTop>
        <img src={PngLogo} alt="logo" className="top-logo" />
        <CancelIcon onClick={sideNavToggle} />
      </SideNavTop>
      <SideNavCenter>
        <img src={PngLogo} alt="logo" className="top-logo" />
        {type === AccountPath.USER ? (
          <>
            {STUDENT_NAVIGATION.navItems.map((item, index) => (
              <SideNavItem
                active={pathname
                  ?.split("/")[3]
                  ?.toLowerCase()
                  .includes(item.url.toLowerCase())}
                key={index}
                icon={item.icon}
                text={item.text}
                onClick={() => handleItemClick(index, item)}
                isMessage={isMessage}
              />
            ))}
          </>
        ) : type === AccountPath.SYSTEM_ADMIN ? (
          <>
            {SYSTEM_ADMIN_NAVIGATION.navItems.map((item, index) => (
              <SideNavItem
                active={pathname
                  ?.split("/")[3]
                  ?.toLowerCase()
                  .includes(item.url.toLowerCase())}
                key={index}
                icon={item.icon}
                text={item.text}
                onClick={() => handleItemClick(index, item)}
                isMessage={isMessage}
              />
            ))}
          </>
        ) : type === AccountPath.SUPER_ADMIN ? (
          <>
            {SUPER_ADMIN_NAVIGATION.navItems.map((item, index) => (
              <SideNavItem
                active={pathname
                  ?.split("/")[3]
                  ?.toLowerCase()
                  .includes(item.url.toLowerCase())}
                key={index}
                icon={item.icon}
                text={item.text}
                onClick={() => handleItemClick(index, item)}
                isMessage={isMessage}
              />
            ))}
          </>
        ) : null}
      </SideNavCenter>
      {/* <SideNavBottom>
        <ul>
          <li onClick={() => history.push("/")}>About</li>
          <li onClick={() => history.push("/dashboard/user/privacy-policy")}>
            Privacy
          </li>
          <li onClick={() => history.push("/dashboard/user/terms&condition")}>
            Terms
          </li>
          <li onClick={() => history.push("/dashboard/user/faq-session")}>
            FAQs
          </li>
        </ul>
        <p>
          &copy; 2021 <span onClick={() => history.push("/")}>compass.ng</span>
        </p>
      </SideNavBottom> */}
    </SideNavStyle>
  );
}
